import Marquee from "react-fast-marquee";
import logo01 from "../../images/brand/LogoCocaBlanco.png";
import logo02 from "../../images/brand/topochicoblanco.png";
import logo03 from "../../images/brand/Cinepolis-white.png";
import logo04 from "../../images/brand/ArcaLogoBlanco.png";
import logo05 from "../../images/brand/FemsaLogoBlanco.png";
import logo06 from "../../images/brand/hnkwhithelogo.png";
import logo07 from "../../images/brand/CinemexLogoBlanco.png";
import logo08 from "../../images/brand/petstarLogoBlanco.png";

const BrandSection: React.FC = () => {
    return (
        <section className="brand pt-170 pb-150" >
            <div className="container">
                <div className="xb-brand-wrap xb-border">
                    <div className="brand-sub-title xb-border">
                        <p>
                            Las marcas <span> que han confiado </span> en nosotros
                        </p>
                    </div>


                    <Marquee speed={40} gradient={false} pauseOnHover={false}>
                        <div className="brand-marquee marquee-left">
                            <div className="xb-brand-inner ul_li_between">
                                {[logo01, logo02, logo03, logo04, logo05, logo06, logo07, logo08].map(
                                    (logo, index) => (
                                        <div className="xb-brand-item" key={index}>
                                            <img src={logo} alt={`logo ${index + 1}`} />
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </Marquee>

                </div>
            </div>
        </section>
    );
};

export default BrandSection;


